import { useChangeLayout } from 'hooks'
import { useGetTicket, useParkDetails } from 'pages/park_car/ParkCarHooks'
import useBuyMoreTime from 'pages/park_car/ParkCarHooks/useBuyMoreTime'
import { CancelParkCarDialog } from 'pages/park_car_credit_card/CreditCardComponents'
import usePaymentCard from 'pages/park_car_credit_card/CreditCardComponents/creditCardHooks/usePaymentCard'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect, useParams } from 'react-router-dom'
import { paths } from 'routing'
import { AppSnackBarProvider, AppSpinner, WhiteBoxContainer } from 'shared'
import { parkCarSlice } from 'store/slices'
import { useAppDispatch } from 'store/store'
import Translations from 'utils/translations'
import ParkCarView from './ParkCarSummaryView'
import HybridRecaptcha from '../../shared/ReCaptcha/HybridRecaptcha'
import { reCaptchaFeature } from 'shared/ReCaptcha/ParkerLinkReCaptcha'
import { useSnackbar } from 'notistack'
import { FlexBox } from 'shared'

export const AddTimeSummaryPage: React.FC = props => {
  const { ticketId } = useParams<{ ticketId: string }>()
  const { t } = useTranslation()
  const [showDialog, setShowDialog] = React.useState(false)
  const title = t(Translations.PARK_CAR)
  const { externalPricingId, pricingPayload } = useParkDetails()
  const [loading, , submitBMT] = useBuyMoreTime()
  const { paymentCard } = usePaymentCard()
  const [, , ticket] = useGetTicket()
  const dispatch = useAppDispatch()
  const [recaptchaToken, setRecaptchaToken] = React.useState<string | null>(
    null
  )
  const [recaptchaVerified, setRecaptchaVerified] = React.useState(false)
  const handleTokenReceived = (token: string) => {
    setRecaptchaToken(token)
  }

  const handleRecaptchaSuccess = () => {
    setRecaptchaVerified(true)
  }
  const { enqueueSnackbar } = useSnackbar()
  const handleRecaptchaFailure = () => {
    enqueueSnackbar(t(Translations.RECAPTCHA_VERIFICATION_FAILED), {
      variant: 'error',
    })
    setRecaptchaVerified(false)
  }

  const onClickRight = () => {
    setShowDialog(true)
  }
  useChangeLayout(
    {
      topbar: {
        title,
        hasGoBack: loading ? false : true,
        rightIcon: loading ? null : 'close',
        onClickRight,
      },
      bottomMenu: false,
    },
    'app',
    [loading]
  )
  React.useEffect(
    () => () => {
      dispatch(parkCarSlice.actions.setZipCode(''))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [dispatch]
  )

  if (!ticketId || !ticket || (!externalPricingId && !pricingPayload)) {
    return <Redirect to={paths.parking.tickets} />
  }

  return (
    <AppSnackBarProvider>
      <WhiteBoxContainer minHeight={150}>
        <AppSpinner show={loading} />
        {ticket && paymentCard && (
          <>
            <FlexBox hasTopMargin>
              <HybridRecaptcha
                onValidationSuccess={handleRecaptchaSuccess}
                onValidationFailure={handleRecaptchaFailure}
                onTokenReceived={handleTokenReceived}
                feature={reCaptchaFeature.Payment}
              />
            </FlexBox>
            <ParkCarView
              ticket={ticket}
              card={paymentCard}
              onSubmit={() => {
                if (!recaptchaVerified) {
                  enqueueSnackbar(
                    t(Translations.PLEASE_COMPLETE_RECAPTCHA_VERIFICATION),
                    { variant: 'warning' }
                  )
                  return
                }
                submitBMT(recaptchaToken)
              }}
              paid={false}
              pending={loading}
              summaryProps={ticket}
            />
          </>
        )}
      </WhiteBoxContainer>
      <CancelParkCarDialog
        open={showDialog}
        closeDialog={() => setShowDialog(false)}
      />
    </AppSnackBarProvider>
  )
}

export default AddTimeSummaryPage
